import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export const apiFetchTenantShares = async ({
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.tenantShares(),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
